import { useEffect } from 'react';
import { useLogoutCleanup } from '../api/reactQueryHook/useAuth';

function AuthenticationManagement() {
  const { cleanup } = useLogoutCleanup();

  useEffect(() => {
    // inline function to invoke the logout cleanup
    const handleAuthenticationFailed: () => void = () => {
      cleanup({
        msg: 'Session expired',
      });
    };

    window.addEventListener(
      'authentication-management',
      handleAuthenticationFailed
    );
    return () => {
      window.removeEventListener(
        'authentication-management',
        handleAuthenticationFailed
      );
    };
  }, [cleanup]);

  return null; // no UI, just a listener
}

export default AuthenticationManagement;
